/** The six volumes together, used in the hero and the pricing box. */
export const PRODUCT_SET_IMAGE =
  'https://cdn.magicpatterns.com/uploads/w3LFr6Rbja77wDRjqTaAma/Professional-product-hero-photograph-3.png'
